import _defineProperty from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS } from '../globals';
import { ReadOnlyMap } from '../read-only-map';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  // Bug #61: The channelCountMode should be 'max' according to the spec but is set to 'explicit' to achieve consistent behavior.
  channelCountMode: 'explicit',
  channelInterpretation: 'speakers',
  numberOfInputs: 1,
  numberOfOutputs: 1,
  parameterData: {},
  processorOptions: {}
};
export var createAudioWorkletNodeConstructor = function createAudioWorkletNodeConstructor(addUnrenderedAudioWorkletNode, audioNodeConstructor, createAudioParam, createAudioWorkletNodeRenderer, createNativeAudioWorkletNode, getAudioNodeConnections, getBackupOfflineAudioContext, getNativeContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, sanitizeAudioWorkletNodeOptions, setActiveAudioWorkletNodeInputs, testAudioWorkletNodeOptionsClonability, wrapEventListener) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(AudioWorkletNode, _audioNodeConstructor);

    var _super = _createSuper(AudioWorkletNode);

    function AudioWorkletNode(context, name, options) {
      var _this;

      _classCallCheck(this, AudioWorkletNode);

      var _a;

      var nativeContext = getNativeContext(context);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var mergedOptions = sanitizeAudioWorkletNodeOptions(_objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options)); // Bug #191: Safari doesn't throw an error if the options aren't clonable.

      testAudioWorkletNodeOptionsClonability(mergedOptions);
      var nodeNameToProcessorConstructorMap = NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS.get(nativeContext);
      var processorConstructor = nodeNameToProcessorConstructorMap === null || nodeNameToProcessorConstructorMap === void 0 ? void 0 : nodeNameToProcessorConstructorMap.get(name); // Bug #186: Chrome, Edge and Opera do not allow to create an AudioWorkletNode on a closed AudioContext.

      var nativeContextOrBackupOfflineAudioContext = isOffline || nativeContext.state !== 'closed' ? nativeContext : (_a = getBackupOfflineAudioContext(nativeContext)) !== null && _a !== void 0 ? _a : nativeContext;
      var nativeAudioWorkletNode = createNativeAudioWorkletNode(nativeContextOrBackupOfflineAudioContext, isOffline ? null : context.baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, mergedOptions);
      var audioWorkletNodeRenderer = isOffline ? createAudioWorkletNodeRenderer(name, mergedOptions, processorConstructor) : null;
      /*
       * @todo Add a mechanism to switch an AudioWorkletNode to passive once the process() function of the AudioWorkletProcessor
       * returns false.
       */

      _this = _super.call(this, context, true, nativeAudioWorkletNode, audioWorkletNodeRenderer);
      var parameters = [];
      nativeAudioWorkletNode.parameters.forEach(function (nativeAudioParam, nm) {
        var audioParam = createAudioParam(_assertThisInitialized(_this), isOffline, nativeAudioParam);
        parameters.push([nm, audioParam]);
      });
      _this._nativeAudioWorkletNode = nativeAudioWorkletNode;
      _this._onprocessorerror = null;
      _this._parameters = new ReadOnlyMap(parameters);
      /*
       * Bug #86 & #87: Invoking the renderer of an AudioWorkletNode might be necessary if it has no direct or indirect connection to
       * the destination.
       */

      if (isOffline) {
        addUnrenderedAudioWorkletNode(nativeContext, _assertThisInitialized(_this));
      }

      var _getAudioNodeConnecti = getAudioNodeConnections(_assertThisInitialized(_this)),
          activeInputs = _getAudioNodeConnecti.activeInputs;

      setActiveAudioWorkletNodeInputs(nativeAudioWorkletNode, activeInputs);
      return _this;
    }

    _createClass(AudioWorkletNode, [{
      key: "onprocessorerror",
      get: function get() {
        return this._onprocessorerror;
      },
      set: function set(value) {
        var wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
        this._nativeAudioWorkletNode.onprocessorerror = wrappedListener;
        var nativeOnProcessorError = this._nativeAudioWorkletNode.onprocessorerror;
        this._onprocessorerror = nativeOnProcessorError !== null && nativeOnProcessorError === wrappedListener ? value : nativeOnProcessorError;
      }
    }, {
      key: "parameters",
      get: function get() {
        if (this._parameters === null) {
          // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
          return this._nativeAudioWorkletNode.parameters;
        }

        return this._parameters;
      }
    }, {
      key: "port",
      get: function get() {
        return this._nativeAudioWorkletNode.port;
      }
    }]);

    return AudioWorkletNode;
  }(audioNodeConstructor);
};